import React, { useEffect, useState } from 'react'
import NewsArticle from '../news/NewsArticle'


const News = () => {

   
  return (
    <div className='news'>
        
        <NewsArticle />
    </div>
  )
}

export default News